module.exports = __webpack_public_path__ + "static/subset-UniNeueBook-db7ffe8210780de2172a56296c5d6965.woff2";